import { useState } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { galleryImages } from "../../data/dummyData";

const GalleryList = () => {
  const [selectedImg, setSelectedImg] = useState(0);
  const [imgPop, setImgPop] = useState(false);

  const swipeImg = (moveType) => {
    if (moveType === "prv") {
      setSelectedImg((prev) =>
        prev === 0 ? galleryImages.length - 1 : prev - 1
      );
    } else if (moveType === "nxt") {
      setSelectedImg((prev) =>
        prev === galleryImages.length - 1 ? 0 : prev + 1
      );
    }
  };

  return (
    <>
      {/* Gallery Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 gap-4 mt-10">
        {galleryImages.map((image, index) => (
          <div
            onClick={() => {
              setSelectedImg(index);
              setImgPop(true);
            }}
            key={image.id}
            className="relative cursor-pointer group hover:scale-105 transition-transform ease-in-out"
          >
            <img
              src={image.image}
              alt={`Gallery Image ${image.id}`}
              className="w-full h-64 object-cover "
            />
            <div className="absolute inset-0 bg-black bg-opacity-40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center rounded-lg">
              <p className="text-white font-bold  text-lg">View Image</p>
            </div>
          </div>
        ))}
      </div>

      {/* Popup Modal */}
      {imgPop && (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
          {/* Close Button */}
          <button
            onClick={() => setImgPop(false)}
            className="absolute top-5 right-5 text-white text-2xl"
            aria-label="Close Image"
          >
            <FaTimes />
          </button>

          {/* Previous Button */}
          <button
            onClick={() => swipeImg("prv")}
            className="absolute left-5 text-white text-3xl"
            aria-label="Previous Image"
          >
            <FaChevronLeft />
          </button>

          {/* Main Image */}
          <div className="max-w-full max-h-full p-4">
            <img
              src={galleryImages[selectedImg].image}
              alt={`Gallery Image ${galleryImages[selectedImg].id}`}
              className="max-w-full max-h-[80vh] "
            />
          </div>

          {/* Next Button */}
          <button
            onClick={() => swipeImg("nxt")}
            className="absolute right-5 text-white text-3xl"
            aria-label="Next Image"
          >
            <FaChevronRight />
          </button>
        </div>
      )}
    </>
  );
};

export default GalleryList;
